/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import * as React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';

export default function ConfirmOptoutDialog({handleClose, withButton, buttonText, buttonColor, ...props}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseDialog = (selectValue) => {
    //console.log("handleClose", selectValue);
    if(selectValue!==undefined && selectValue!==null && selectValue!==false){
      // callback to the parent component
      handleClose(selectValue);
    }
    setOpen(false);
  };

  return (
    <React.Fragment>
      {withButton && (
        <Box display="flex" justifyContent="flex-end">
          <Button variant="outlined" color={buttonColor ? buttonColor : "error"} onClick={handleClickOpen}>
            {buttonText ? buttonText : "Opt Out"}
          </Button>
        </Box>
      )}
      {!withButton && (
        {...props}
      )}
      <Dialog
        open={open}
        onClose={() => handleCloseDialog(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to opt out of research?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to opt out of research? This will remove your data from the study and you will no longer be able to participate.
            <br />
            You can NOT undo this action.
            <br />
            If you are sure you want to opt out, click Agree.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialog(false)}>Disagree</Button>
          <Button onClick={() => handleCloseDialog(true)} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

// Prop types validation
ConfirmOptoutDialog.propTypes = {
  handleClose: PropTypes.func.isRequired, // Function to handle dialog close
  withButton: PropTypes.bool, // Boolean to determine if button should be displayed
  buttonText: PropTypes.string, // Text to display on the button
  buttonColor: PropTypes.string, // Color of the button
};

ConfirmOptoutDialog.defaultProps = {
  withButton: true, // Default value for withButton
  buttonText: "Opt Out", // Default button text
  buttonColor: "error", // Default button color
};
